/**
 * Whether IndexedDB is usable here. Absent under Lockdown Mode — iOS strips it
 * from WebViews and Safari strips it from the page itself.
 *
 * Kept in its own module so boot code can gate the (heavier) stand-in imports
 * on it without pulling `fake-indexeddb` into the entry bundle.
 */
export function hasIndexedDB(): boolean {
  return (
    typeof globalThis.indexedDB !== "undefined" && globalThis.indexedDB != null
  );
}
